import '~/css/shared/cookies-consent-dialog.css';

import Cookies from 'js-cookie';

import httpClient from "@/bundles/http-client";

class CookiesConsentDialog
{
    el;

    cookieConsentName = 'cookieconsent_status';
    cookieConsentValue = 'dismiss';

    init() {
        if (this._isUrlIneligible() || this._wasDismissed()) {
            return;
        }

        this._load();
    }

    _load() {
        httpClient.get('/partials/cookies-consent').then(response => {
            const html = response.data;
            const wrapper = document.createElement('div');
            wrapper.innerHTML = html;

            document.body.appendChild(wrapper);

            this.el = document.getElementById('cookiesConsentDialog');

            this.el.querySelector('.btn-dismiss').addEventListener('click', () => {
                this._dismiss();
            });

            this._show();
        })
    }

    _isUrlIneligible() {
        const url = window.location.pathname;
        const ineligiblePaths = [
            '/quote',
        ];

        for (const path of ineligiblePaths) {
            if (url.indexOf(path) === 0) {
                return true;
            }
        }

        return false;
    }

    _show() {
        this.el.classList.remove('d-none');
    }

    _hide() {
        this.el.classList.add('d-none');
    }

    _wasDismissed() {
        const cookieValue = Cookies.get(this.cookieConsentName);

        return cookieValue === this.cookieConsentValue;
    }

    _dismiss() {
        Cookies.set(this.cookieConsentName, this.cookieConsentValue, { expires: 365, sameSite: 'strict' });
        this._hide();
    }
}

const cookiesConsentDialog = new CookiesConsentDialog();
cookiesConsentDialog.init();
